import React from 'react';
import { LegalDocumentPage } from './LegalDocumentPage';

const sections = [
  {
    title: '수집하는 정보',
    body: [
      '운영팀은 로그인과 서비스 제공에 필요한 최소한의 정보만 수집합니다. 수집 항목에는 소셜 로그인 식별 정보, 닉네임, 프로필 정보, 커뮤니티 활동 정보, 주문 및 결제 확인 정보, 접속 로그가 포함될 수 있습니다.',
      '회원 유형, 복무 유형, 입대일, 소속 정보 등 사용자가 직접 입력한 프로필 정보는 개인화된 서비스와 기능 제공을 위해 사용됩니다.',
    ],
  },
  {
    title: '수집 방법',
    body: [
      '개인정보는 회원가입 및 로그인 과정, 프로필 작성, 게시글 작성, 주문 및 결제 이용, 고객지원 문의 과정에서 사용자가 직접 제공하거나 서비스 이용 과정에서 자동으로 생성됩니다.',
      '외부 인증 또는 결제 서비스와 연동되는 경우 해당 제공자가 전달한 범위 내의 정보만 수집·처리합니다.',
    ],
  },
  {
    title: '이용 목적',
    body: [
      '수집된 정보는 사용자 인증, 서비스 운영, 개인화된 정보 제공, 커뮤니티 관리, 주문 및 결제 처리, 보안 대응, 서비스 개선에 활용됩니다.',
    ],
    bullets: [
      '회원 식별 및 로그인 상태 유지',
      '프로필 및 개인화 기능 제공',
      '커뮤니티 게시물·댓글·신고 처리',
      '주문, 결제, 결제 확인 및 환불 처리',
      '오류 분석, 서비스 품질 개선, 부정 이용 방지',
    ],
  },
  {
    title: '보관 기간',
    body: [
      '개인정보는 수집 목적이 달성되면 지체 없이 파기하는 것을 원칙으로 합니다. 다만 관계 법령에 따라 일정 기간 보관이 필요한 경우 해당 기간 동안 안전하게 보관합니다.',
      '회원 탈퇴 또는 개인정보 삭제 요청이 접수된 경우, 법령상 보관 의무가 있는 정보를 제외하고는 지체 없이 삭제 또는 분리 보관 절차를 진행합니다.',
    ],
  },
  {
    title: '제3자 제공 및 처리위탁',
    body: [
      '운영팀은 원칙적으로 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만 법령상 의무 이행, 결제 처리, 인증 처리, 보안 대응 등 서비스 운영에 필요한 범위에서는 외부 서비스 제공자와 정보를 처리할 수 있습니다.',
      '인증, 데이터 저장, 결제 처리, 로그 관리 등 일부 기능은 신뢰 가능한 외부 서비스 제공자를 통해 운영될 수 있습니다.',
    ],
  },
  {
    title: '이용자의 권리',
    body: [
      '사용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지 요청을 할 수 있으며, 운영팀은 관계 법령이 허용하는 범위에서 지체 없이 조치합니다.',
      '서비스 내에서 직접 수정 가능한 정보는 마이페이지 등 제공된 기능을 통해 수정할 수 있습니다.',
    ],
  },
  {
    title: '쿠키와 로그 정보',
    body: [
      '서비스는 로그인 유지, 보안 확인, 환경 설정 저장, 트래픽 분석을 위해 쿠키 또는 유사 기술을 사용할 수 있습니다.',
      '브라우저 설정을 통해 쿠키 저장을 제한할 수 있으나, 이 경우 일부 로그인 및 맞춤형 기능 이용이 제한될 수 있습니다.',
    ],
  },
  {
    title: '안전성 확보 조치',
    body: [
      '운영팀은 접근 권한 관리, 인증 토큰 보호, 저장 데이터 접근 제어, 전송 구간 보호, 로그 모니터링 등 합리적인 수준의 기술적·관리적 보호조치를 시행합니다.',
      '다만 인터넷 환경의 특성상 완전한 보안을 절대적으로 보장할 수는 없으므로, 사용자도 계정과 기기 보안에 주의를 기울여야 합니다.',
    ],
  },
] as const;

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <LegalDocumentPage
      eyebrow="Privacy"
      title="개인정보처리방침"
      description="짬밥요리사가 어떤 정보를 수집하고, 어떤 목적으로 이용하며, 얼마 동안 보관하고 보호하는지에 대한 기준을 안내합니다."
      sections={[...sections]}
    />
  );
};
